import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'claytec',
} as IModuleProps;
